var $ = require( "jquery" )

$(document).ready( function(){
  $('.remove-photo')
    .on('ajax:success', function(event) {
      if (event.detail[0].success) {
        $(event.target).closest('.thumb-and-tools').remove();
      } else {
        alert('Unable to delete photo');
      }
    })
    .on('ajax:error', function() {
      alert('Unable to delete photo: ajax error');
    });
});
